import React from "react";

const font = '"DM Sans", sans-serif';

function Badge({ children, color = "#ff4b4f", wrap = false }) {
  return (
    <span
      style={{
        fontSize: 11,
        padding: "3px 10px",
        borderRadius: 20,
        fontFamily: font,
        fontWeight: 500,
        background: `${color}18`,
        color,
        border: `1px solid ${color}30`,
        whiteSpace: wrap ? "normal" : "nowrap",
        maxWidth: wrap ? "100%" : undefined,
        wordBreak: wrap ? "break-word" : undefined,
        overflowWrap: wrap ? "anywhere" : undefined,
        boxSizing: "border-box",
      }}
    >
      {children}
    </span>
  );
}

export default Badge;
